import * as azmaps from 'azure-maps-control';

export interface ElementInfo {
    attr?: { [key: string]: string };
    class?: string[];
    style?: { [key: string]: any };
    propName?: string;
    innerHTML?: string;
    children?: HTMLElement[];
}

export class Utils {
    public static createElm(type: 'button' | 'canvas' | 'div' | 'input' | 'select' | 'label' | 'br', elmInfo?: ElementInfo, resx?: { [key: string]: any }): HTMLElement {
        const elm = document.createElement(type);

        if (elmInfo) {
            if (elmInfo.propName && resx) {
                const r = resx[elmInfo.propName];
                if (r) {
                    elmInfo.attr = Object.assign(elmInfo.attr || {}, {
                        'alt': r,
                        'title': r,
                    });
                }
            }

            if(elmInfo.attr)
                Utils.setAttributes(elm, elmInfo.attr);

            if (elmInfo.class) {
                elmInfo.class.forEach(c => {
                    if (c) {
                        elm.classList.add(c);
                    }
                });
            }

            if (elmInfo.style) {
                Object.assign(elm.style, elmInfo.style);
            }

            if(elmInfo.children)
                Utils.appendChildren(elm, elmInfo.children);

            if (elmInfo.innerHTML) {
                elm.innerHTML += elmInfo.innerHTML;
            }
        }

        return elm;
    }

    public static appendChildren(elm: HTMLElement, children: HTMLElement[]): void {
        if (elm && children) {
            children.forEach(c => {
                elm.appendChild(c);
            });
        }
    }

    public static setAttributes(elm: HTMLElement, attr: { [key: string]: string }): void {
        if (elm && attr) {
            Object.keys(attr).forEach(k => {
                elm.setAttribute(k as string, attr[k]);
            });
        }
    }

    public static getPolygon(shape: azmaps.data.Polygon | azmaps.data.MultiPolygon | azmaps.data.Feature<azmaps.data.Geometry, any> | azmaps.Shape): azmaps.data.Polygon | azmaps.data.MultiPolygon {
        let poly: azmaps.data.Polygon | azmaps.data.MultiPolygon;

        if (shape instanceof azmaps.Shape) {
            if (shape.isCircle()) {
                poly = new azmaps.data.Polygon([shape.getCircleCoordinates()]);
            } else if (shape.getType().indexOf('Polygon') > -1) {
                poly = <azmaps.data.Polygon>shape.toJson().geometry;
            }
        } else {
            const f = <azmaps.data.Feature<azmaps.data.Geometry, any>>shape;

            if (f.type === 'Feature') {
                if (f.geometry.type === 'Point' && f.properties.subType === 'Circle' && typeof f.properties.radius === 'number') {
                    poly = new azmaps.data.Polygon(azmaps.math.getRegularPolygonPath((f.geometry as azmaps.data.Point).coordinates, f.properties.radius, 72, 'meters'));
                } else if (f.geometry.type.indexOf('Polygon') > -1) {
                    poly = <azmaps.data.Polygon>f.geometry;
                }
            }

            if (f.type && f.type.indexOf('Polygon') !== -1) {
                poly = <azmaps.data.Polygon>shape;
            }
        }

        // @ts-ignore
        return poly;
    }

    public static getGeometry(shape: azmaps.data.Feature<azmaps.data.Geometry, any> | azmaps.Shape): azmaps.data.Geometry {
        if (shape instanceof azmaps.Shape) {
            if (shape.isCircle()) {
                return new azmaps.data.Polygon([shape.getCircleCoordinates()]);
            }
            return shape.toJson().geometry;
        } else {
            const p = Utils.getPolygon(shape);
            if (p) {
                return p;
            }
            return shape.geometry;
        }
    }
}